module.exports = __webpack_public_path__ + "img/Room5_011.d047b5d4.svg";